module.exports = __webpack_public_path__ + "static/media/STPLong2w522@1x.9fba7d55.jpg";